import { jsxs, jsx } from "react/jsx-runtime";
const ConversationSkeleton = () => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: "768px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px"
      },
      children: [
        /* @__PURE__ */ jsx("div", { style: { display: "flex", justifyContent: "flex-end", animation: "fadeIn 0.3s ease-in" }, children: /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: "min(70%, 280px)",
              height: "48px",
              backgroundColor: "#EEF4FC",
              borderRadius: "18px",
              borderBottomRightRadius: "5px",
              animation: "pulse 1.5s ease-in-out infinite"
            }
          }
        ) }),
        /* @__PURE__ */ jsx("div", { style: { display: "flex", justifyContent: "flex-start", animation: "fadeIn 0.3s ease-in 0.2s both" }, children: /* @__PURE__ */ jsxs("div", { style: { width: "100%", display: "flex", flexDirection: "column", gap: "8px" }, children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                width: "100%",
                height: "80px",
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                animation: "pulse 1.5s ease-in-out infinite"
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                width: "85%",
                height: "60px",
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                animation: "pulse 1.5s ease-in-out infinite",
                animationDelay: "0.2s"
              }
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx("style", { children: `
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        ` })
      ]
    }
  );
};
const ConciergePageSkeleton = () => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        minHeight: "-webkit-fill-available",
        backgroundColor: "#ffffff"
      },
      children: [
        /* @__PURE__ */ jsx("style", { children: `
          @keyframes concierge-pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.4; }
          }
        ` }),
        /* @__PURE__ */ jsxs("div", { style: { flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "16px", padding: "24px" }, children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                width: "140px",
                height: "18px",
                backgroundColor: "#f0f0f0",
                borderRadius: "9px",
                animation: "concierge-pulse 1.5s ease-in-out infinite"
              }
            }
          ),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }, children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  width: "280px",
                  height: "24px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "12px",
                  animation: "concierge-pulse 1.5s ease-in-out infinite",
                  animationDelay: "0.1s"
                }
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  width: "220px",
                  height: "24px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "12px",
                  animation: "concierge-pulse 1.5s ease-in-out infinite",
                  animationDelay: "0.2s"
                }
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column", gap: "8px", padding: "0 24px 16px", alignItems: "center" }, children: [200, 240, 180, 220].map((width, i) => /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: `${width}px`,
              maxWidth: "100%",
              height: "44px",
              backgroundColor: "#f8f8f8",
              borderRadius: "22px",
              animation: "concierge-pulse 1.5s ease-in-out infinite",
              animationDelay: `${0.1 * i}s`
            }
          },
          i
        )) }),
        /* @__PURE__ */ jsx("div", { style: { padding: "12px 24px 24px", display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: "100%",
              maxWidth: "768px",
              height: "48px",
              backgroundColor: "#f8f8f8",
              borderRadius: "24px",
              border: "1px solid #f0f0f0",
              animation: "concierge-pulse 1.5s ease-in-out infinite",
              animationDelay: "0.3s"
            }
          }
        ) })
      ]
    }
  );
};
export {
  ConciergePageSkeleton,
  ConversationSkeleton
};
//# sourceMappingURL=ConversationSkeleton.js.map
